import { useIntl } from "react-intl";

import { LoggedInConfluenceBlueWaveTemplate } from "../../components";

export const LoggedInConfluenceStandard = () => {
    const { formatMessage } = useIntl();
    return (
        <LoggedInConfluenceBlueWaveTemplate
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudStandard",
                defaultMessage: "Cloud Standard"
            })}
        />
    );
};
